/**
 * Query and filter models for analytics
 */

import { EventCategory, EventSeverity } from './analytics-event.model';

/**
 * Base event query parameters
 */
export interface EventQueryParams {
  page?: number;
  limit?: number;
  category?: EventCategory | string;
  eventType?: string; // Supports wildcards (e.g., 'auth.*') and comma-separated values
  severity?: EventSeverity | string; // Supports comma-separated values
  userId?: string;
  startDate?: string; // ISO 8601 format
  endDate?: string; // ISO 8601 format
  hours?: number; // Alternative to startDate/endDate
}

/**
 * Platform admin query parameters (extends base with orgId)
 */
export interface PlatformEventQueryParams extends EventQueryParams {
  orgId?: string;
}

/**
 * Time range filter
 */
export interface TimeRangeFilter {
  startDate: string;
  endDate: string;
}

/**
 * Applied filters information
 */
export interface AppliedFilters {
  category?: string | null;
  eventType?: string | null;
  severity?: string | null;
  userId?: string | null;
  orgId?: string | null;
  timeRange?: TimeRangeFilter;
}

/**
 * Security event query parameters
 */
export interface SecurityEventQueryParams {
  severity?: EventSeverity | string;
  hours?: number;
  limit?: number;
}

/**
 * Struggling users query parameters
 */
export interface StrugglingUsersQueryParams {
  hours?: number;
  minErrors?: number;
}

/**
 * User activity query parameters
 */
export interface UserActivityQueryParams {
  hours?: number;
  limit?: number;
}

/**
 * Performance metrics query parameters
 */
export interface PerformanceMetricsQueryParams {
  hours?: number;
}

/**
 * Organization activity query parameters
 */
export interface OrganizationActivityQueryParams {
  hours?: number;
  limit?: number;
}

/**
 * Audit trail query parameters
 */
export interface AuditTrailQueryParams {
  resourceType: string;
  resourceId: string;
}
